import { NavigationItem } from './model';

/**
 * Determines a navigation item's target ID for visibility mapping
 * with the format of "${name}_{index}" or "nav-menu-btn_${index}"
 * @param navItem function | object
 * @param index number
 * @returns "${name}_{index}" or "nav-menu-btn_${index}"
 */
export const determineNavItemTargetId = (
  navItem: NavigationItem,
  index: number,
): string => {
  if (typeof navItem === 'function' || typeof navItem.label !== 'string') {
    return `nav-menu-btn_${index}`;
  }

  return `${navItem.label.replace(/\s/g, '').toLowerCase()}_${index}`;
};

/**
 * Helper function to determine if a menu item should be rendered in the overflow menu
 * Filters out functions (like OrgName) and only shows items that are not visible in the main nav
 * @param item NavigationItem - The navigation item to check
 * @param index number - The index of the item
 * @param visibilityMap - Map of visibility states for navigation items
 * @returns boolean - true if the item should be rendered, false otherwise
 */
export const shouldRenderMenuItem = (
  item: NavigationItem,
  index: number,
  visibilityMap: { [key: string]: boolean },
): boolean => {
  return (
    typeof item !== 'function' &&
    !visibilityMap[determineNavItemTargetId(item, index)]
  );
};
